import React, { useReducer, useState } from 'react';
import Cookies from 'universal-cookie';
import api from './ApiCall';
import { LOADER_MESSAGE, CommonContext, PAGINATION_INFO } from './../constant/ActionTypes';
import { commonReducer } from './../reducer/commonReducer';
import Snackbar from './../../common/Snackbar/Snackbar';

const cookies = new Cookies();

const initialState = {
    loaderMsg: '',
    pagination: null
}

const CommonProvider = (props) => {

    const [commonState, dispatch] = useReducer(commonReducer, initialState);

    const [snackbar, setSnackbar] = useState({
        open: false,
        varient: '',
        message: ''
    });

    const handleSnackbar = (snack=false, varient='', message='') => {
        setSnackbar({
            ...snackbar,
            varient: varient,
            message: message,
            open: snack
        })
    };

    const updateLoaderMsg = (msg = '') => {
        dispatch({
            type: LOADER_MESSAGE,
            payload: msg
        });
    }

    const updatePagination = (info = null) => {
        dispatch({
            type: PAGINATION_INFO,
            payload: info
        });
    }

    return (
        <CommonContext.Provider
			value={{
				...commonState,
                updateLoaderMsg: updateLoaderMsg,
                updatePagination: updatePagination,
                handleSnackbar: handleSnackbar
			}}
		>
			{props.children}
            <Snackbar
                snackbar={snackbar}
                handleSnackbar={() => handleSnackbar()}
            />
		</CommonContext.Provider>
    );
}

export default CommonProvider;



// WEBPACK FOOTER //
// ./contexts/provider/CommonContext.js